import { PrintRegentsCtrl } from './print-regents.controller';

export const PrintRegentsComponent = {
  controller: PrintRegentsCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./print-regents.html'),
};
